"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import TextDroppableInput from "../text_droppable_input";
import CustomerTypeAhead from "../customer_typeahead";
import LookupAddressApi from "../../api/lookup_address";
const LOADING = "Loading...";
const NO_RESULTS_FOUND = "No results found.";
const viewFields = ({
  props,
  state: {
    form,
    isShowingAddress,
    matches,
    errors,
    errorMessages,
    selectedCustomer
  },
  actions: {
    update,
    lookupAddressById,
    fillAddress,
    toggle,
    blur,
    updateCustomer
  }
}) => {
  const labelledField = (inputFn) => (field) => {
    const { key, width, label, required } = field;
    return /* @__PURE__ */ jsxs(
      "label",
      {
        className: "form__input" + (width ? ` form__input--${width}` : ""),
        children: [
          /* @__PURE__ */ jsx("span", { children: label }),
          required ? /* @__PURE__ */ jsxs("span", { className: "form__optional", children: [
            /* @__PURE__ */ jsx("span", { className: "show_for_non_reskin", children: " \u2013 " }),
            /* @__PURE__ */ jsx("span", { children: "required" })
          ] }) : "",
          /* @__PURE__ */ jsx("div", { className: "form__error", children: errorMessages[key] }),
          inputFn(field)
        ]
      }
    );
  };
  const input = (type) => labelledField(({ key, required }) => {
    const value = type === "date" && form[key] ? form[key].split("T")[0] : form[key];
    return /* @__PURE__ */ jsx(
      TextDroppableInput,
      {
        type,
        name: key,
        required,
        value,
        className: errors[key] || errorMessages[key] ? "form__error" : "",
        onDrop: update(key),
        onChange: update(key),
        onBlur: blur({ key, required })
      }
    );
  });
  const viewSelect = (field) => {
    const { key, options, required } = field;
    const option_tags = [];
    if (Array.isArray(options)) {
      option_tags.push(
        ...options.map((option, i) => /* @__PURE__ */ jsx("option", { value: option, children: option }, i))
      );
    } else {
      option_tags.push(
        ...Object.keys(options).map((key2) => /* @__PURE__ */ jsx("option", { value: key2, children: options[key2] }, key2))
      );
    }
    return /* @__PURE__ */ jsxs(
      "select",
      {
        name: key,
        value: form[key] || field["default"],
        onChange: update(key),
        className: errors[key] ? "form__error" : "",
        onBlur: blur({ key, required }),
        children: [
          !required && !field["default"] ? /* @__PURE__ */ jsx("option", { value: "", children: "Select an option" }) : "",
          option_tags
        ]
      }
    );
  };
  const lookup = (field) => {
    const { fieldKey } = field;
    const match = matches[fieldKey];
    const message = typeof match === "string" ? match : void 0;
    let content = "";
    if (message) {
      content = /* @__PURE__ */ jsx("p", { children: message });
    } else if (match) {
      content = /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsxs("a", { onClick: fillAddress(fieldKey, match), children: [
        'Select "',
        match.address.name,
        '"'
      ] }) });
    }
    return /* @__PURE__ */ jsxs("div", { children: [
      labelledField(({ key }) => /* @__PURE__ */ jsx(
        "input",
        {
          type: "search",
          value: form[key],
          onChange: lookupAddressById(fieldKey)
        }
      ))(field),
      content
    ] });
  };
  const fields = {
    text: input("text"),
    date: input("date"),
    lookup,
    select: labelledField(viewSelect),
    row({ fields: fields2 }) {
      return /* @__PURE__ */ jsx("div", { className: "form__row", children: fields2.map(viewField) });
    }
  };
  fields.address = ({ key, labels, required }) => {
    return /* @__PURE__ */ jsx("div", { className: "form", children: addressFields(key, labels, required).map(viewField) });
  };
  fields.labeledAddress = (field) => {
    return /* @__PURE__ */ jsxs("fieldset", { className: "form__fieldset", children: [
      /* @__PURE__ */ jsx("div", { className: "form__legend-wrapper", children: /* @__PURE__ */ jsx("legend", { className: "form__legend", children: field.label }) }),
      fields.address(field)
    ] });
  };
  fields.lookupAddress = (field) => {
    const { key, label, required } = field;
    const toggleLabel = isShowingAddress[key] ? "Lookup by ID" : "Enter manually";
    const content = isShowingAddress[key] ? fields.address(field) : fields.lookup({
      fieldKey: key,
      key: `${key}_lookup`,
      label: "Lookup by ID"
    });
    return /* @__PURE__ */ jsxs("fieldset", { className: "form__fieldset", children: [
      /* @__PURE__ */ jsxs("div", { className: "form__legend-wrapper", children: [
        /* @__PURE__ */ jsxs("legend", { className: "form__legend", children: [
          /* @__PURE__ */ jsx("span", { children: label }),
          required ? /* @__PURE__ */ jsxs("span", { className: "form__optional", children: [
            /* @__PURE__ */ jsx("span", { className: "show_for_non_reskin", children: " \u2013 " }),
            /* @__PURE__ */ jsx("span", { children: " required" })
          ] }) : ""
        ] }),
        /* @__PURE__ */ jsx("a", { className: "form__toggle", onClick: toggle(field), children: toggleLabel })
      ] }),
      content
    ] });
  };
  fields.customerPicker = labelledField(({ key }) => /* @__PURE__ */ jsx(
    CustomerTypeAhead,
    {
      customer: selectedCustomer,
      onSelectCustomer: updateCustomer(key),
      onClearCustomer: updateCustomer(key)
    }
  ));
  const viewField = (field, i) => {
    const view = fields[field.type];
    if (!view) {
      console.warn("WARN", `Unrecognized type ${field.type} provided...`);
      return null;
    }
    return /* @__PURE__ */ jsx("div", { className: "form__field", children: view(field) }, i);
  };
  return props.fields.map(viewField);
};
const addressFields = (key, labels = {}, required) => [
  {
    type: "text",
    key: `${key}_name`,
    label: labels.name || "Name",
    width: "large",
    required
  },
  {
    type: "row",
    fields: [
      {
        type: "text",
        key: `${key}_address_line_1`,
        label: labels.address_line_1 || "Address Line 1",
        width: "medium",
        required
      },
      {
        type: "text",
        key: `${key}_address_line_2`,
        label: labels.address_line_2 || "Address Line 2"
      }
    ]
  },
  {
    type: "row",
    fields: [
      {
        type: "text",
        key: `${key}_city`,
        label: labels.city || "City",
        required
      },
      {
        type: "text",
        key: `${key}_state`,
        label: labels.state || "State",
        width: "small",
        required
      },
      {
        type: "text",
        key: `${key}_postal_code`,
        label: labels.postal_code || "Postal Code",
        required
      }
    ]
  }
];
const requiredFieldMapping = (fields) => {
  const reducer = (obj, field) => subFields(field) ? __spreadValues(__spreadValues({}, obj), subFields(field).reduce(reducer, {})) : __spreadProps(__spreadValues({}, obj), { [field.key]: field.required || false });
  return reducer({}, { fields });
};
const subFields = ({ key, labels, fields, type, required }) => {
  switch (type) {
    case "labeledAddress":
    case "lookupAddress":
      return addressFields(key, labels, required);
    default:
      return fields ? fields : void 0;
  }
};
const isMissingRequiredFields = ({ fields, data }) => Object.entries(requiredFieldMapping(fields)).some(
  ([key, isRequired]) => isRequired && !data[key]
);
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      form: __spreadValues({}, this.props.form),
      selectedCustomer: this.props.customer,
      errors: {},
      errorMessages: {},
      isShowingAddress: {},
      matches: {}
    });
    __publicField(this, "formWasUpdated", (form) => {
      const hasErrors = isMissingRequiredFields({
        fields: this.props.fields,
        data: form
      });
      this.props.onFormUpdate(hasErrors, form, this.setErrorMessages);
    });
    __publicField(this, "setErrorMessages", (errors) => {
      this.state.errorMessages = errors;
      this.setState(this.state);
    });
    __publicField(this, "update", (key) => {
      return (e, value) => {
        this.state.form[key] = value || e.target.value;
        this.setState(this.state);
        this.formWasUpdated(this.state.form);
      };
    });
    __publicField(this, "updateCustomer", (key) => {
      return (customer) => {
        if (customer) {
          this.state.form[key] = customer.id;
          this.state.selectedCustomer = customer;
        } else {
          this.state.form[key] = null;
          this.state.selectedCustomer = null;
        }
        this.setState(this.state);
        this.formWasUpdated(this.state.form);
      };
    });
    __publicField(this, "blur", ({ key, required }) => {
      return (e) => {
        const hasValue = this.state.form[key];
        if (required && !hasValue) {
          this.state.errors[key] = true;
        } else {
          this.state.errors[key] = false;
        }
        this.setState(this.state);
      };
    });
    __publicField(this, "toggle", (field) => {
      return (e) => {
        this.state.isShowingAddress[field.key] = !this.state.isShowingAddress[field.key];
        this.setState(this.state);
      };
    });
    __publicField(this, "lookupAddressById", (key) => {
      return (e) => {
        this.state.matches[key] = LOADING;
        this.setState(this.state);
        LookupAddressApi.lookupById(e.target.value).then((match) => this.state.matches[key] = match).catch((_) => this.state.matches[key] = NO_RESULTS_FOUND).then((_) => this.setState(this.state));
      };
    });
    __publicField(this, "fillAddress", (key, { external_id, address }) => {
      return (e) => {
        const form = this.state.form;
        form[`${key}_name`] = external_id;
        form[`${key}_address_line_1`] = address.address_line_1;
        form[`${key}_address_line_2`] = address.address_line_2;
        form[`${key}_city`] = address.city;
        form[`${key}_state`] = address.state;
        form[`${key}_postal_code`] = address.postal_code;
        this.state.isShowingAddress[key] = true;
        this.state.matches[key] = void 0;
        this.setState(this.state);
        this.formWasUpdated(this.state.form);
      };
    });
  }
  componentDidMount() {
    this.formWasUpdated(this.state.form);
  }
  render() {
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("h3", { className: "load-detail__section-header", children: "Load Details" }),
      /* @__PURE__ */ jsx("div", { className: "form dynamic_form", children: viewFields({
        props: this.props,
        state: this.state,
        actions: {
          update: this.update,
          lookupAddressById: this.lookupAddressById,
          fillAddress: this.fillAddress,
          toggle: this.toggle,
          blur: this.blur,
          updateCustomer: this.updateCustomer
        }
      }) })
    ] });
  }
}
